class AccordionGroup extends HTMLElement {
  constructor() {
    super();

    this.openEvent = 'accordion:open';
    this.accordionSelector = 'domaine-accordion';
  }

  connectedCallback() {
    this.addEventListener(this.openEvent, this.onAccordionOpen.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener(this.openEvent, this.onAccordionOpen);
  }

  onAccordionOpen(e) {
    this.accordions = [...this.querySelectorAll(this.accordionSelector)];
    if (!this.accordions.length) return;

    this.accordions.map((accordion) => accordion.toggleAttribute('will-close', e.target !== accordion));
  }
}

customElements.define('domaine-accordion-group', AccordionGroup);
